import React from "react";
import { Check, UtensilsCrossed, Wrench, Scissors, Building2 } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { Seo } from "../components/Seo";
import { PoseEagle } from "../components/PoseEagle";
import { Band } from "../components/Band";

const icons = [UtensilsCrossed, Wrench, Scissors, Building2];
const slugs = ["restaurants", "plumbers-home-services", "barbers-salons", "local-service-businesses"];

export default function IndustriesPage() {
  const { t } = useI18n();
  return (
    <main className="pt-40 lg:pt-36" data-testid="industries-page">
      <Seo k="industries" />
      <Band tone="light" className="pb-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
          <div className="max-w-2xl">
            <div className="eyebrow mb-3">{t.nav.industries}</div>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter">{t.industriesPage.title}</h1>
            <p className="text-slate-400 mt-4 text-lg">{t.industriesPage.sub}</p>
          </div>
          <PoseEagle
            src="/eagle-poses/eagle-industries-gliding.png"
            size={155}
            mobileSize={90}
            entrance="glide"
            testid="industries-eagle"
            className="flex justify-end mt-4 md:mt-0 md:absolute md:right-6 lg:right-12 md:bottom-[-24px]"
          />
        </div>
      </Band>

      <Band tone="dark" className="py-14">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-2 gap-4">
          {t.industriesPage.list.map((ind, i) => {
            const Icon = icons[i] || Building2;
            return (
              <div key={i} id={slugs[i]} className="glass rounded-2xl p-7 scroll-mt-36" data-testid={`industry-${i}`}>
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div>
                    <div className="w-12 h-12 rounded-xl bg-blue-600/15 border border-blue-400/30 text-cyan-300 flex items-center justify-center mb-4">
                      <Icon size={20} />
                    </div>
                    <h3 className="font-display font-bold text-white text-2xl">{ind.title}</h3>
                    <p className="text-slate-400 mt-2 leading-relaxed">{ind.desc}</p>
                  </div>
                </div>
                <ul className="mt-5 pt-5 border-t border-white/5 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                  {ind.items.map((item, ii) => (
                    <li key={ii} className="flex items-start gap-2 text-sm text-slate-200">
                      <Check size={14} className="text-blue-400 mt-0.5 shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
          </div>
        </div>
      </Band>
    </main>
  );
}
